import { useState } from 'react'
import { ModalButton, FullscreenModal, CaseDetails } from 'components'
import { NewCaseModal } from '../CaseDetails'
import { useTranslation } from 'react-i18next'

export const NewCaseButton = ({ type, onSave, getItems }) => {
  const [showButtonModal, setShowButtonModal] = useState(false)
  const [showFullModal, setShowFullModal] = useState(false)
  const { t } = useTranslation()
  return (
    <>
      <ModalButton
        left
        primary
        text={t('newPrintPackage.newCase')}
        icon="plus"
        show={[showButtonModal, setShowButtonModal]}
        data-testid="new-case-button"
      >
        <NewCaseModal
          setShowCaseModal={setShowFullModal}
          setShowButtonModal={() => setShowButtonModal(false)}
          type={type}
          onSave={onSave}
          getItems={getItems}
        />
      </ModalButton>
      <FullscreenModal show={[showFullModal, setShowFullModal]}>
        {showFullModal && <CaseDetails />}
      </FullscreenModal>
    </>
  )
}

export default NewCaseButton
